import * as STD from '@emersya/mpa-std';
import * as CM       from '@emersya/mpa-components-manager';
// https://developer.mozilla.org/en-US/docs/Web/HTML/Link_types
export type TRelAttribute = (
	'alternate' |
	'author' |
	'bookmark' |
	'external' |
	'help' |
	'license' |
	'me' |
	'next' |
	'nofollow' |
	'noopener' |
	'noreferrer' |
	'opener' |
	'prev' |
	'search' |
	'tag'
	);
export type TTargetAttribute = (
	'_self' | //Current browsing context. (Default)
	'_blank' | //New tab, but users can changes it.
	'_parent' | //Parent browsing context. If no parent, behaves as _self.
	'_top'      //Topmost browsing context. If no ancestors, behaves as _self.
	);

export interface ILinkComponentConfiguration extends CM.DOMComponent.IConfiguration {
	nameForDownlload? : string;
	href? : string;
	rel? : TRelAttribute;
	target? : TTargetAttribute;
	// type?              : string; //mimetype, not used currently
	'@translations' : CM.DOMComponent.IConfiguration['@translations'] & {
		text? : STD.translationsManager.TranslationMapping;
		href? : STD.translationsManager.TranslationMapping;
	};
};

// Can be <a> or <link> but only <a> supported currently
export class LinkComponent extends CM.DOMComponent<HTMLAnchorElement, LinkComponent, ILinkComponentConfiguration> {
	component_DOM : HTMLAnchorElement;

	updateText(s : string) {
		this.component_DOM.textContent = s;
	};

	updateHref(s : string) {
		this.component_DOM.href = s;
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : ILinkComponentConfiguration
	)
	{
		super(descriptor, configuration);

		const attributes: Record<string, string> = {};
		if (configuration.rel) attributes.rel = configuration.rel;
		if (configuration.target) attributes.target = configuration.target;

		this.component_DOM = <HTMLAnchorElement> STD.DOM.factory({
			tag :        'a',
			attributes
		});

		if (configuration.href) {
			this.updateHref(configuration.href);
		}
		if (this.component_hasTranslation('text')) {
			this.component_DOM.dataset.translation = this.component_getTranslationId('text');
		}
		if (this.component_hasTranslation('href')) {
			this.component_DOM.href = <string> this.component_getTranslationId('href');
		}
	};
};

export namespace NS {
	export type Component = LinkComponent;
	export const Component = LinkComponent;
	export type Configuration = ILinkComponentConfiguration;
}
;
CM.Manager.declare({
	id :   'link',
	type : LinkComponent
});
